<div class="empty-page-template">
  @if (!isStatic()) {
    <cx-page-slot position="FreeZone" />
  } @else {
    <div class="error-500">
      <div class="logo">
        <sd-icon name="icon-brand" aria-hidden="true" />
      </div>
      <sd-teaser [data]="dataTeaser()" [twicPicsAutoSize]="false" />
    </div>
  }
</div>
